// @ts-ignore
import CryptoJS from 'crypto-js';

export function decrypt(encryptedText: string, date: string, token:string) {
    try {
        const key = `${date}${token}`;
        const bytes = CryptoJS.AES.decrypt(encryptedText, key);
        const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedText);
    } catch (error) {
        console.log(error)
    }
}

export async function cropImg(base64Image: string,) {
    // 创建一个临时的 Image 对象
    const img = new Image();
    img.src = base64Image;
    return new Promise((resolve, reject) => {
        img.onload = () => {
            try {
                // 创建 Canvas
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                // 检查 ctx 是否为空
                if (!ctx) {
                    reject('无法创建 Canvas 上下文');
                    return
                }
                // 设置 Canvas 大小为最终需要的尺寸
                canvas.width = 80;
                canvas.height = 80;
                // 计算裁剪位置
                const sourceX = (850 - 530) / 2;  // 160
                // 绘制和裁剪图片
                ctx.drawImage(
                    img,
                    sourceX, 229,    // 开始剪切的位置
                    530, 529,           // 剪切的尺寸
                    0, 0,               // 放置在画布上的位置
                    80, 80             // 最终显示尺寸
                );
                // 转换回 base64
                resolve(canvas.toDataURL('image/png'))
            } catch (e) {
                reject(e)
            }
        }
        img.onerror = reject
    })
}
